import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Patient, PatientPlanTypes } from '../models';
import { Api, Session } from '../services/index';
import * as moment from 'moment';
import { MyModal } from '../components/modal/modal';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-exam-request-care-today',
  templateUrl: './exam-request-care-today.html',
  styleUrls: ['exam-request-care-today.css']
})

export class ExamRequestCareToday implements OnInit {
  loading: boolean = false;
  lob: string;
  patient: Patient;
  patientDependents: Patient[] = [];
  listCursor = { cursor: 'pointer' };

  dependentsAllowed: boolean = true;
  patientPlanTypes: Array<PatientPlanTypes>;
  bhPlan = false;

  @ViewChild('myIncompleteProfile') public _modalIncompleteProfile: MyModal;
  constructor(private api: Api,
    private route: ActivatedRoute,
    private router: Router,
    private session: Session) {
  }

  ngOnInit() {
    this.loading = true;
    console.log('exam-request-care-today.ts ngOnInit api.getDependentsAllowed');

    this.api.getDependentsAllowed(this.session.patientId).subscribe(response => {
      console.log('api.getDependentsAllowed:', response);
      this.dependentsAllowed = response;
    });

    let _getPatientPlanTypes = this.api.getPatientPlanTypes(this.session.patientId).map(planTypeResults => {
      this.patientPlanTypes = planTypeResults;
    });

    let _patient = this.api.getMember(this.session.patientId).map(response => {
      this.patient = response;
    });

    Observable.forkJoin([
      _getPatientPlanTypes,
      _patient
		]).subscribe(results => {

      if (this.validatePatientProfile(this.patient)) {

        if (this.patient.avatar) {
          this.patient.avatar = this.session.environment.settings.patientAvatarBucket + this.patient.avatar;
        } else if (this.patient.profile.gender.toUpperCase() == 'F') {
          this.patient.avatar = '../../assets/images/patient-avatar-female.png';
        } else {
          this.patient.avatar = '../../assets/images/patient-avatar-male.png';
        }

        this.patientDependents.push(this.patient);

        if(this.patientPlanTypes.length > 0){
          this.patientPlanTypes.forEach(plans => {
            switch (plans.planTypeCode) {
              case 'THI':
              case 'BH':
              case 'PSI':
              case 'YT':
                this.bhPlan = true;
                break;
            }
          });
        }

        if (!this.bhPlan) {
          let dependents = this.api.getDependents(this.session.patientId);
          dependents.subscribe(response => {
            let patientDependents = response;
            patientDependents = patientDependents.filter((value, index) => {
              return !this.checkIsOver18(value.profile.dateOfBirth) || value.userId == this.session.patientId;
            });

            for (let i = 0; i < patientDependents.length; i++) {
              if (patientDependents[i].avatar) {
                patientDependents[i].avatar = this.session.environment.settings.patientAvatarBucket + patientDependents[i].avatar;
              } else if (patientDependents[i].profile.gender.toUpperCase() == 'F') {
                patientDependents[i].avatar = '../../assets/images/patient-avatar-female.png';
              } else {
                patientDependents[i].avatar = '../../assets/images/patient-avatar-male.png';
              }
              this.patientDependents.push(patientDependents[i]);
            }
            let _patientDependents =  this.getUnique(this.patientDependents, 'userId'); 
            this.patientDependents = _patientDependents;
            this.loading = false;
          });
        }
        this.loading = false;
      } else {
        this.router.navigate(['/dashboard-my-profile']);
      }






    })
  }

  getIntakeLOB() {
    return this.session.intakeLob;
  }

  checkIsOver18(date: Date) {
    let dateOfBirth = moment(date);
    let now = moment().utc(true);
    return (now.diff(dateOfBirth, 'years') >= 18)
  }

  addFamilyMember() {
    this.router.navigate(['/family-member'], { queryParams: { requestExam: true } });
  }
  gotoProfile(update) {
    if (update) {
      this.router.navigate(['/dashboard-my-profile']);
    } else {
      this.router.navigate(['/dashboard-my-profile']);
    }
    this._modalIncompleteProfile.close();
  }
  profileTapped(profile: Patient) {
    this.loading = true;
    console.log('profiletapped');
    switch (this.session.intakeLob) {
      case 'PAS': // Screening(? todo confirm )

        console.log('this.session.intakeLob;', this.session.intakeLob);

        this.router.navigate(['/bh-screen-what-to-expect']);
        break;
      default:

        let patient = this.api.getMember(profile.userId);
        patient.subscribe(response => {
          this.session.patient = response;
          this.loading = false;
          this.router.navigate(['/exam-reason-for-exam/' + profile.userId]);
        });
        break;
    }
  }

  validatePatientProfile(patient): boolean {
    let isValidProfile: boolean = true;

    return isValidProfile;
  }

  getUnique(arr, comp) {

    const unique = arr
         .map(e => e[comp])

      .map((e, i, final) => final.indexOf(e) === i && i)

      .filter(e => arr[e]).map(e => arr[e]);
  
     return unique;
  }



}
